module.exports = __webpack_public_path__ + "media/images/credit-cards-e9fc5658a65458121a3eb4d1f7db3af8.png";